import React, { useEffect, useState } from 'react';
import styled from 'styled-components'
import { collection, query, doc, deleteDoc, getDocs } from "firebase/firestore";
import { getFirestore } from "firebase/firestore"
import { ToastContainer,  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ActuDashBoard = () => {

    const [articleList,setArticleList] = useState([]);
    const db = getFirestore();
    const [refresh,setRefresh] = useState(false)
  
    const getDataArticle = async () => {

      
        let completeList = []
        const q = query(collection(db, "articles"));
        const querySnapshot = await getDocs(q);
        const pushArray = async () => {
            
        await querySnapshot.forEach((doc) => {
    
                
                completeList.push({ id: doc.id, title: doc.data().title, description: doc.data().description, image: doc.data().img})
                
            })}   
        pushArray();
         
       setArticleList(completeList)
       
        
    }

    useEffect(()=>{

        getDataArticle()
        

    },[refresh])
    
    

    

    
    
    const handleChange = (e) => {

        const {name, checked} = e.target

        if(name === 'selectall'){
            let tempEmail = articleList.map((item) => {
                return {...item, isChecked: checked}
            })
            
            setArticleList(tempEmail)

        }else{
             let tempEmail = articleList.map((item) => {
            return  item.title === name ? {...item, isChecked: checked} : item 
        
        })
        setArticleList(tempEmail);
        }
            
        }

        let fullList = articleList.filter((item) =>  {

             if(item?.isChecked){
                return item            
        }})
        

        const handleDelete = (id) => {
            
            toast.error('Article supprimé', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
            setRefresh(!refresh)
            const deleteAction = async () => {

                await deleteDoc(doc(db, "articles",id ));
            }
            deleteAction();   
           
            

        }
        
    



    return (
        <Container>
            <ToastContainer/>
            <Header>
                <ul>
                    <li>Selection</li>
                    <li>Id</li>
                    <li>contenu</li>
                    <li>Action</li>
                   
                </ul>
            </Header>
            <form >
                <div className="selectAll"  >
                <input type="checkbox" name="selectall" id="selectall" onChange={handleChange} checked={articleList.filter((item) => !item.isChecked).length >= 1 ? false : true}  />
                <label htmlFor="selectall">Select All</label>
                </div>

                {articleList.slice(0,10).map((item)=>{

                    return (
                <div key={item.title} className="row">

               
                    <input type="checkbox" name={item.title} id={item.title} checked={item.isChecked || false}  onChange={handleChange} />
                    <p>{item.id}</p>
                    <label htmlFor={item.title}>{item.title !== "" && item.title !== undefined  ? item.description.slice(0,15) + "..." : "Aucun titre"}</label>
                    <div className="action">
                        <span className='buttonform' onClick={() =>handleDelete( item.title)}>Delete</span>
                    
                    </div>
                    
                    

                 </div>
                    )

                })}
                 
            </form>

                

        </Container>
    );
};


const Header = styled.div`
margin-top: 10px;
width: 100%;
height: 50px;
background-color: rgb(160,160,246, 0.8);
box-shadow: rgb(0,0,0,0.2) 0px 5px 20px;

display:flex;
justify-content: flex-start;
align-items:center;


ul{
    padding: 0 50px;
    width: 100%;
    display:flex;    
    justify-content: space-between;
    list-style:none;
    align-items:flex-end; 

  
    }
}`

const Container = styled.div`
width: 100%
height:100%;
display:flex;
flex-direction: column;
font-family: 'Poppins';
font-weight: 600;
color: #5E5873;

form{
    width: 100%;
    display:flex;
    flex-direction: column;    
    align-items:flex-start;    

    .selectAll{
        padding: 20px 25px;
        input{
            margin-right: 10px;
        }
    }

    .row{
        margin: 5px 0px;
        width:100%;
        display:flex;
        justify-content: space-between;
        align-items:center;
        padding: 0px 25px;

   

    p{
        padding: 0px 0px;
        width:100px;
        display:flex;
        justify-content:flex-start;
        align-items:flex-start;
        overflow:hidden;
        
        height: 18px;
        

     
        
        text-align:left;
        font-size: 12px;
        padding: 0px 20px;
    }

    label{
        width: 100px;
        overflow:hidden;
        height: 18px;
        display:flex;
        justify-content: flex-start;
        align-items:flex-start;
        
        
    }

    .buttonform{
        border: none;
        border-radius: 8px;
        font-size: 14px;
        font-family:'Poppins';
        font-weight: 500;
        padding: 2px 10px;
        background: #7367F0;
        margin-left: 5px;

        &:hover{
            background: rgb(0,0,0,0.8);
            color: #f9f9f9;
            cursor: pointer;
        }
    }
    } 
    
   

    }

   
}
`

export default ActuDashBoard;